'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
var getThemeProp = require('../../utils/getThemeProp.js');

var StyledFormControlLabel = styled__default(core.FormControlLabel)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  .MuiSvgIcon-root {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  .Mui-checked .MuiSvgIcon-root {\n    fill: ", ";\n  }\n  .MuiCheckbox-colorPrimary.Mui-disabled {\n    svg {\n      fill: #6e84a3;\n    }\n  }\n  .MuiTypography-body1 {\n    line-height: inherit;\n  }\n"], ["\n  .MuiSvgIcon-root {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  .Mui-checked .MuiSvgIcon-root {\n    fill: ", ";\n  }\n  .MuiCheckbox-colorPrimary.Mui-disabled {\n    svg {\n      fill: #6e84a3;\n    }\n  }\n  .MuiTypography-body1 {\n    line-height: inherit;\n  }\n"])), getThemeProp('palette.primary.main', 'blue'));
var templateObject_1;

exports.StyledFormControlLabel = StyledFormControlLabel;
